import { Typography, theme } from 'antd'
import {
  FileOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FileZipOutlined,
  CodeOutlined,
  PlaySquareOutlined,
  SoundOutlined,
} from '@ant-design/icons'
import { FileAttachment } from '../../Contracts'
import { getFileCategory, formatFileSize } from '../../Helpers/fileIcon'

const { Text } = Typography

interface FileMessageProps {
  file: FileAttachment
}

const iconMap: Record<string, typeof FileOutlined> = {
  image: FileImageOutlined,
  video: PlaySquareOutlined,
  audio: SoundOutlined,
  pdf: FilePdfOutlined,
  spreadsheet: FileExcelOutlined,
  archive: FileZipOutlined,
  code: CodeOutlined,
  document: FileOutlined,
  unknown: FileOutlined,
}

const FileMessage = ({ file }: FileMessageProps) => {
  const { token } = theme.useToken()

  const category = getFileCategory(file.name)
  const Icon = iconMap[category] ?? FileOutlined

  return (
    // Signed url with Content-Disposition: attachment — the click downloads;
    // _blank keeps the SPA intact if the link has expired (403 page)
    <a
      href={file.url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '4px 0',
        cursor: 'pointer',
        color: 'inherit',
        textDecoration: 'none',
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: 8,
          background: token.colorPrimaryBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Icon style={{ fontSize: 20, color: token.colorPrimary }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <Text
          style={{
            fontSize: 13,
            fontWeight: 500,
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {file.name}
        </Text>
        <Text type="secondary" style={{ fontSize: 12 }}>
          {formatFileSize(file.size)}
        </Text>
      </div>
    </a>
  )
}

export default FileMessage
